"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesClass = exports.MAX_DEFAULT_WALKING_SPEED_KPH = exports.MIN_DEFAULT_WALKING_SPEED_KPH = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const merge_1 = __importDefault(require("lodash/merge"));
const get_1 = __importDefault(require("lodash/get"));
const set_1 = __importDefault(require("lodash/set"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const events_1 = __importDefault(require("events"));
const Status = __importStar(require("../utils/Status"));
const ObjectWithHistory_1 = require("../utils/objects/ObjectWithHistory");
const defaultPreferences_config_1 = __importDefault(require("./defaultPreferences.config"));
const project_config_1 = __importDefault(require("./shared/project.config"));
const LodashExtensions_1 = require("../utils/LodashExtensions");
const lineModesDefaultValues_1 = require("./lineModesDefaultValues");
// Boundaries for the default values of various path parameters. Changing these does not affect the bounds of the parameters themselves, only those of the default param you can configure in the preferences.
exports.MIN_DEFAULT_WALKING_SPEED_KPH = 2.0;
exports.MAX_DEFAULT_WALKING_SPEED_KPH = 7.0;
const MAX_DEFAULT_RUNNING_SPEED_KMH = 500;
const MAX_DEFAULT_DWELL_TIME_SECONDS = 600;
const MIN_DEFAULT_ACCELERATION = 0.3;
const MAX_DEFAULT_ACCELERATION = 1.5;
const MIN_DEFAULT_DECELERATION = 0.3;
const MAX_DEFAULT_DECELERATION = 1.5;
const prefChangeEvent = 'change';
class PreferencesClass extends ObjectWithHistory_1.ObjectWithHistory {
    constructor(attributes = {}, isNew = false) {
        const newAttributes = (0, cloneDeep_1.default)((0, merge_1.default)({}, defaultPreferences_config_1.default, project_config_1.default.defaultPreferences, attributes));
        super(newAttributes, isNew);
        this._eventEmitter = new events_1.default();
        // TODO: ideally, do not let consumers directly access the fields, find a better way
        this._default = (0, cloneDeep_1.default)(defaultPreferences_config_1.default);
        this._projectDefault = (0, cloneDeep_1.default)(project_config_1.default.defaultPreferences || {});
        this._runtimeServer = {};
    }
    get current() {
        return this._attributes;
    }
    /**
     * Override set so that theme-related preference changes emit immediately,
     * allowing the UI theme to update before the user saves preferences.
     */
    set(path, value) {
        super.set(path, value);
        if (path === 'isDarkTheme') {
            this._eventEmitter.emit(prefChangeEvent, { [path]: value });
        }
    }
    /**
     * Override undo so that listeners (e.g. ThemeContext) are notified when
     * isDarkTheme or other preferences are restored from history.
     */
    undo() {
        super.undo();
        this._eventEmitter.emit(prefChangeEvent, this._attributes);
    }
    /**
     * Override redo so that listeners (e.g. ThemeContext) are notified when
     * isDarkTheme or other preferences are restored from history.
     */
    redo() {
        super.redo();
        this._eventEmitter.emit(prefChangeEvent, this._attributes);
    }
    // FIXME: Do the following functions need to be public?
    getDefault() {
        return this._default;
    }
    getProjectDefault() {
        return this._projectDefault;
    }
    getFromDefault(path) {
        return (0, get_1.default)(this.getDefault(), path);
    }
    getFromProjectDefault(path) {
        return (0, get_1.default)(this.getProjectDefault(), path);
    }
    getFromProjectDefaultOrDefault(path) {
        const projectDefaultValue = this.getFromProjectDefault(path);
        if (!(0, LodashExtensions_1._isBlank)((0, get_1.default)(this.getProjectDefault(), path))) {
            return projectDefaultValue;
        }
        else {
            const defaultValue = this.getFromDefault(path);
            return defaultValue;
        }
    }
    // TODO: extract mode related validations to external function (see Path.ts)
    validate() {
        this._isValid = true;
        this._errors = [];
        if (this.attributes.defaultWalkingSpeedMetersPerSeconds < exports.MIN_DEFAULT_WALKING_SPEED_KPH / 3.6) {
            this._isValid = false;
            this._errors.push('main:preferences:errors:DefaultWalkingSpeedMustBeAtLeast2kph');
        }
        else if (this.attributes.defaultWalkingSpeedMetersPerSeconds > exports.MAX_DEFAULT_WALKING_SPEED_KPH / 3.6) {
            this._isValid = false;
            this._errors.push('main:preferences:errors:DefaultWalkingSpeedMustBeAtMost7kph');
        }
        for (let i = 0, count = lineModesDefaultValues_1.lineModesArray.length; i < count; i++) {
            const mode = lineModesDefaultValues_1.lineModesArray[i];
            const defaultAcceleration = this.attributes.transit.lines.lineModesDefaultValues[mode].defaultAcceleration;
            const defaultDeceleration = this.attributes.transit.lines.lineModesDefaultValues[mode].defaultDeceleration;
            const defaultRunningSpeedKmH = this.attributes.transit.lines.lineModesDefaultValues[mode].defaultRunningSpeedKmH;
            const defaultDwellTimeSeconds = this.attributes.transit.lines.lineModesDefaultValues[mode].defaultDwellTimeSeconds;
            const maxRunningSpeedKmH = this.attributes.transit.lines.lineModesDefaultValues[mode].maxRunningSpeedKmH;
            if ((0, isNumber_1.default)(defaultRunningSpeedKmH) &&
                (defaultRunningSpeedKmH <= 0 || defaultRunningSpeedKmH > MAX_DEFAULT_RUNNING_SPEED_KMH)) {
                this.errors.push('transit:transitPath:errors:DefaultRunningSpeedIsInvalid');
                this._isValid = false;
            }
            if ((0, isNumber_1.default)(defaultDwellTimeSeconds) &&
                (defaultDwellTimeSeconds <= 0 || defaultDwellTimeSeconds > MAX_DEFAULT_DWELL_TIME_SECONDS)) {
                if (mode !== 'transferable' || (mode === 'transferable' && defaultDwellTimeSeconds < 0)) {
                    this.errors.push('transit:transitPath:errors:DefaultDwellTimeIsInvalid');
                    this._isValid = false;
                }
            }
            if (!(0, isNumber_1.default)(defaultAcceleration)) {
                this.errors.push('transit:transitPath:errors:DefaultAccelerationIsRequired');
                this._isValid = false;
            }
            else {
                if (defaultAcceleration < 0) {
                    this.errors.push('transit:transitPath:errors:DefaultAccelerationIsInvalid');
                    this._isValid = false;
                }
                else if (defaultAcceleration <= MIN_DEFAULT_ACCELERATION) {
                    this.errors.push('transit:transitPath:errors:DefaultAccelerationIsTooLow');
                    this._isValid = false;
                }
                else if (defaultAcceleration > MAX_DEFAULT_ACCELERATION && mode !== 'transferable') {
                    this.errors.push('transit:transitPath:errors:DefaultAccelerationIsTooHigh');
                    this._isValid = false;
                }
            }
            if (!(0, isNumber_1.default)(defaultDeceleration)) {
                this.errors.push('transit:transitPath:errors:DefaultDecelerationIsRequired');
                this._isValid = false;
            }
            else {
                if (defaultDeceleration < 0) {
                    this.errors.push('transit:transitPath:errors:DefaultDecelerationIsInvalid');
                    this._isValid = false;
                }
                else if (defaultDeceleration <= MIN_DEFAULT_DECELERATION) {
                    this.errors.push('transit:transitPath:errors:DefaultDecelerationIsTooLow');
                    this._isValid = false;
                }
                else if (defaultDeceleration > MAX_DEFAULT_DECELERATION && mode !== 'transferable') {
                    this.errors.push('transit:transitPath:errors:DefaultDecelerationIsTooHigh');
                    this._isValid = false;
                }
            }
            if ((0, isNumber_1.default)(defaultRunningSpeedKmH) && defaultRunningSpeedKmH > maxRunningSpeedKmH) {
                this.errors.push('transit:transitPath:errors:DefaultRunningSpeedIsTooHigh');
                this._isValid = false;
            }
        }
        return this._isValid;
    }
    /**
     * FIXME: Used for preferences edit form
     * @param path Dot-separated path to the preference to reset
     * @returns The new preferences value
     */
    resetPathToDefault(path) {
        const projectDefaultOrDefaultValue = this.getFromProjectDefaultOrDefault(path);
        this.set(path, projectDefaultOrDefaultValue);
        return projectDefaultOrDefaultValue;
    }
    updateFromSocket(socket, valuesByPath) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                socket.emit('preferences.update', valuesByPath, (response) => {
                    if (Status.isStatusOk(response)) {
                        resolve(true);
                    }
                    else {
                        reject(response.error);
                    }
                });
            });
        });
    }
    updateFromFetch(valuesByPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch('/update_user_preferences', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ valuesByPath })
            });
            if (response.status === 200) {
                const jsonResponse = (yield response.json());
                if (Status.isStatusOk(jsonResponse)) {
                    return true;
                }
                else {
                    throw jsonResponse.error;
                }
            }
            else {
                throw 'Invalid response returned from server';
            }
        });
    }
    /**
     * Update preferences value and save to the server
     * @param valuesByPath An object where the keys are the dot-separated path
     * to the preferences to update and the value is the new value of the
     * preference.
     * @param socket Optional, an socket event emitter to use to save the data.
     * If undefined, a post to the server will be done
     * @returns The complete preferences object
     */
    update(valuesByPath_1, socket_1) {
        return __awaiter(this, arguments, void 0, function* (valuesByPath, socket, emitChangeEvent = true) {
            try {
                const _valuesByPath = (0, cloneDeep_1.default)(valuesByPath);
                if (socket) {
                    yield this.updateFromSocket(socket, _valuesByPath);
                }
                else {
                    yield this.updateFromFetch(_valuesByPath);
                }
                if (Object.keys(_valuesByPath).length > 0) {
                    for (const path in _valuesByPath) {
                        (0, set_1.default)(this._attributes, path, _valuesByPath[path]);
                    }
                }
                if (emitChangeEvent) {
                    this._eventEmitter.emit(prefChangeEvent, _valuesByPath);
                }
            }
            catch (_a) {
                console.error('Error loading preferences from server');
            }
            return this._attributes;
        });
    }
    /**
     * Save the whole preferences object to the server
     * FIXME: Used for preferences edit form
     */
    save(socket, eventManager) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (socket) {
                    yield this.updateFromSocket(socket, this.attributes);
                }
                else {
                    yield this.updateFromFetch(this.attributes);
                }
                eventManager === null || eventManager === void 0 ? void 0 : eventManager.emit('preferences.updated');
                this._eventEmitter.emit(prefChangeEvent, this._attributes);
            }
            catch (_a) {
                console.error('Error loading preferences from server');
            }
            return this._attributes;
        });
    }
    // Not implemented for Preferences, we should never delete the preferences object.
    delete(_socket) {
        return new Promise((resolve) => {
            resolve(null);
        });
    }
    /**
     * Update the preferences with server-specific values. Those values are for server data and cannot be overriden by client.
     * This should be called only from the server-side
     *
     * FIXME: Make sure only server can call this function or refactor preferences to avoid this in client.
     * TODO: If we keep this: test
     *
     * @param {*} valuesByPath The values to update
     */
    updateServerPrefs(valuesByPath) {
        const _valuesByPath = (0, cloneDeep_1.default)(valuesByPath);
        if (Object.keys(_valuesByPath).length > 0) {
            for (const path in _valuesByPath) {
                (0, set_1.default)(this._runtimeServer, path, _valuesByPath[path]);
            }
        }
        (0, merge_1.default)(this._attributes, (0, cloneDeep_1.default)(this._runtimeServer));
    }
    loadFromSocket(socket) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                socket.emit('preferences.read', (response) => {
                    if (Status.isStatusOk(response)) {
                        resolve(Status.unwrap(response));
                    }
                    else {
                        reject(response.error || 'Error loading preferences with socket');
                    }
                });
            });
        });
    }
    loadFromFetch() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch('/load_user_preferences', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const jsonResponse = (yield response.json());
                if (Status.isStatusOk(jsonResponse)) {
                    return Status.unwrap(jsonResponse);
                }
                else {
                    throw jsonResponse.error;
                }
            }
            else {
                throw 'Invalid response returned from server';
            }
        });
    }
    /**
     * Load preferences from server
     * @param socket Optional, an socket event emitter to use to load the data.
     * If undefined, a get from the server will be done
     * @returns The complete preferences object
     */
    load(socket) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const preferencesFromServer = socket ? yield this.loadFromSocket(socket) : yield this.loadFromFetch();
                this._attributes = (0, cloneDeep_1.default)((0, merge_1.default)({}, this._default, this._projectDefault, preferencesFromServer));
                this._eventEmitter.emit(prefChangeEvent, this._attributes);
            }
            catch (_a) {
                console.error('Error loading preferences from server');
            }
            return this._attributes;
        });
    }
    // TODO: type this:
    get(path, defaultValue = undefined) {
        return super.get(path, defaultValue);
    }
    /**
     * Add a listener for preferences changes
     *
     * @param callback The function to call when there are changes to the
     * current preferences. The listener will send as parameter the preferences
     * values that have changed
     */
    addChangeListener(callback) {
        this._eventEmitter.on(prefChangeEvent, callback);
    }
    /**
     * Remove a listener for preferences changes
     *
     * @param callback The previously added callback
     */
    removeChangeListener(callback) {
        this._eventEmitter.off(prefChangeEvent, callback);
    }
}
exports.PreferencesClass = PreferencesClass;
PreferencesClass.displayName = 'Preferences';
// singleton:
const instance = new PreferencesClass();
exports.default = instance;
//# sourceMappingURL=Preferences.js.map